import React from 'react';
import { Flex, Text, Button, Dialogs } from '@leverege/ui-elements';
import Util from '../../../../views/salesFlow/Util';
import EnableDialog from './EnableDialog';
import { unpairedLocatorSupport } from '../Templates';
import { ONE_HOUR_IN_MS } from '../../../../constants';
import S from './TheftRecovery.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TheftRecoveryInactive(props) {
  const {
    sharedProps: {
      item
    }
  } = props;
  const activated = Util.isLocatorActivated(item?.data?.locator);
  const contactSupport = () => {
    const messageText = unpairedLocatorSupport.replace('$VIN', item?.data?.vin || 'Unknown');
    window?.Intercom('showNewMessage', messageText);
  };
  const onClick = () => {
    Dialogs.show({
      component: EnableDialog,
      props
    });
  };
  const getWarning = () => {
    const {
      sharedProps: {
        item
      }
    } = props;
    const locator = item?.data?.locator?.data;
    let text;
    if (locator?.lastHeartbeat < Date.now() - 3 * ONE_HOUR_IN_MS) {
      text = 'This locator has been offline for over three hours. We may not be able to get a position.';
    }
    if (locator?.batteryLevel < 20) {
      text = 'Your locator battery is below 20%. Theft recovery mode uses more battery power and may kill your battery faster.';
    }
    if (!locator) {
      text = 'Vehicle must be paired with a Locator to enable Theft Recovery Mode.';
    }
    if (text?.length) {
      return /*#__PURE__*/_jsx(Flex, {
        variant: "rowL",
        children: /*#__PURE__*/_jsx(Text, {
          variant: "theftRecoveryInfo",
          children: text
        })
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colL",
    children: [getWarning(), /*#__PURE__*/_jsx(Text, {
      children: "Enable theft recovery mode if you think your vehicle has been stolen. The next time that the locator checks in, it will start reporting position updates up to every 3 minutes while theft recovery mode is active."
    }), /*#__PURE__*/_jsx(Button, {
      variant: activated ? 'secondaryDestructive' : 'secondary',
      className: S.button,
      onClick: activated ? onClick : contactSupport,
      children: activated ? 'Enable Theft Recovery' : 'Contact Support'
    })]
  });
}